module.exports = __webpack_public_path__ + "02_veryshort_brown.048abc9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/02_veryshort_brown.png
// module id = Yp8p
// module chunks = 0